import Register from "../../components/organisms/register/Register";
import "./LoginTemplate.css";

const LoginTemplate = ({ navigate, register }) => {
  const handleBack = () => {
    // Revient à la page précédente réelle dans l'historique
    // (ex: "/" si on venait de l'accueil, "/alertes" si on venait de là).
    // Si aucun historique n'existe (arrivée directe sur /register),
    // on retombe sur /alertes par sécurité.
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/notifications"); // Fallback si pas d'historique
    }
  };

  return (
    <div className="auth-page">
      <button className="back-btn" onClick={handleBack}>
        ← Retour
      </button>

      <div className="auth-container">
        {/* Left panel — static info panel */}
        <div className="info-panel">
          <h1>Surveillez le risque d'incendie en temps réel !</h1>
          <p>
            Recevez des notifications précoces,  
            <br />
            Suivez les conditions météo  
            <br />
            Et surveillez votre zone d’intérêt
          </p>
        </div>

        {/* Right panel — always the register form */}
        <div className="form-panel">
          <Register register={register} />
        </div>
      </div>
    </div>
  );
};

export default LoginTemplate;